module.exports = __webpack_public_path__ + "static/media/pexels-pixabay-235990-final.b55af6cc.jpg";